import { useCanManageEmployees } from 'utils/useCanManageEmployees';
import { Box, Button, SvgIcon } from '@mui/material';
import ImportsDrawer from 'components/@home/@people/ImportsDrawer';
import Alert from 'components/alerts/Alert';
import FileUpload from 'mdi-react/FileUploadIcon';
import ms from 'ms';
import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import employeesActions from 'store/app/entities/employees/action';
import employeeImportsActions from 'store/app/ui/drawers/employeeImports/action';
import { I18n } from 'utils/i18n';

const autoHideDuration = ms('10 seconds');

const ImportEmployeesButton = () => {
  const canManageEmployees = useCanManageEmployees();
  const dispatch = useDispatch();
  const fileInput = useRef();
  const form = useRef();
  const alertInitialState = { isOpen: false };
  const [alert, setAlert] = useState(alertInitialState);
  const onClose = () => {
    setAlert(a => ({ ...a, ...alertInitialState }));
  };
  const handleChange = async event => {
    try {
      const {
        value: {
          data: { created, updated },
        },
      } = await dispatch(employeesActions.createImport(event.target.files[0]));
      setAlert({
        isOpen: true,
        variant: 'success',
        message: I18n.t('ImportUsers.Success'),
        caption: I18n.t('ImportUsers.CreatedUpdated', { created, updated }),
      });
    } catch (e) {
      setAlert({
        isOpen: true,
        variant: 'error',
        message: e.data?.message || I18n.t('AttachFile.Errors.Unexpected error'),
        caption: '',
      });
    }
  };

  if (!canManageEmployees) {
    return null;
  }

  return (
    <>
      <Button
        component={Button}
        variant="outlined"
        color="secondary"
        sx={{ mr: '10px', color: 'primary.ultraDark' }}
        onClick={() => dispatch(employeeImportsActions.open())}
      >
        <SvgIcon sx={{ fontSize: 18, mr: '5px', color: 'primary.main' }}>
          <FileUpload />
        </SvgIcon>
        {I18n.t('PeoplesScene.Import employees')}
      </Button>
      <Box component="form" sx={{ display: 'none' }} ref={form}>
        <input
          ref={fileInput}
          onChange={handleChange}
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          type="file"
        />
      </Box>
      <Alert
        isOpen={alert.isOpen}
        variant={alert.variant}
        onClose={onClose}
        label={I18n.t('PeoplesScene.Import employees')}
        caption={alert.caption}
        autoHideDuration={autoHideDuration}
      >
        {alert.message}
      </Alert>
      <ImportsDrawer />
    </>
  );
};

export default ImportEmployeesButton;
